import myClient from './myClient.vue'
import myTemplate from './myTemplate.vue';

export default {
  myTemplate,
  myClient
}
